import * as yup from 'yup'

const schema = yup.object().shape({
  responsibles: yup
    .array()
    .min(1, 'Selecione pelo menos um responsável')
    .required(),
})

export default schema
